{
  "DATA_ASSISTANT": {
    "TITLE": "Dataassistent",
    "NEW_CONVERSATION": "+ Ny",
    "LOADING": "Läser in...",
    "LOADING_MESSAGES": "Läser in meddelanden...",
    "THINKING": "Tänker...",
    "UNTITLED": "Namnlös konversation",
    "NO_CONVERSATIONS": "Inga konversationer än. Klicka på \"+ Ny\" för att börja.",
    "EMPTY_STATE": "Välj en konversation eller skapa en ny för att börja.",
    "PLACEHOLDER": "Vad kan jag ta reda på åt dig?",
    "SHOW_SQL": "Visa SQL",
    "NO_ROWS": "Inga rader returnerades.",
    "DELETE": "×",
    "DELETE_CONFIRM": "Radera konversation",
    "DELETE_CONFIRM_DESCRIPTION": "Är du säker på att du vill radera den här konversationen? Denna åtgärd kan inte ångras.",
    "DELETE_CONFIRM_YES": "Radera",
    "REPORTS": "Rapporter",
    "SAVE_TO_REPORT": "Spara i rapport",
    "NEW_REPORT": "Ny rapport",
    "REPORT_NAME": "Rapportnamn",
    "NO_REPORTS": "Inga sparade rapporter än",
    "REPORTS_EMPTY_STATE": "Välj en rapport eller skapa en ny.",
    "REPORT_SAVED": "Sparat i rapport",
    "DELETE_REPORT_CONFIRM": "Radera rapport",
    "DELETE_REPORT_CONFIRM_DESCRIPTION": "Är du säker på att du vill radera den här rapporten? Alla sparade objekt tas bort.",
    "DELETE_ITEM_CONFIRM": "Ta bort objekt",
    "DELETE_ITEM_CONFIRM_DESCRIPTION": "Är du säker på att du vill ta bort det här objektet från rapporten?",
    "EXPORT_CSV": "Exportera CSV",
    "REFRESH": "Uppdatera",
    "QUERY_RUNNING": "Kör fråga...",
    "QUERY_FAILED": "Frågan misslyckades",
    "AUTO_REFRESH": "Automatisk uppdatering",
    "AUTO_REFRESH_NONE": "Manuellt",
    "AUTO_REFRESH_30S": "30 sekunder",
    "AUTO_REFRESH_1M": "1 minut",
    "AUTO_REFRESH_5M": "5 minuter",
    "AUTO_REFRESH_10M": "10 minuter",
    "EDIT_MESSAGE": "Redigera meddelande",
    "RENAME_REPORT": "Byt namn på rapport",
    "RENAME_ITEM": "Byt namn på objekt",
    "MOVE_UP": "Flytta upp",
    "MOVE_DOWN": "Flytta ner",
    "COLLABORATORS": {
      "BUTTON": "Medarbetare",
      "TITLE": "Medarbetare på rapporten",
      "DESCRIPTION": "Välj vilka agenter och team som kan se den här rapporten.",
      "AGENTS": "Agenter",
      "TEAMS": "Team",
      "SELECT_AGENTS": "Välj agenter",
      "SELECT_TEAMS": "Välj team",
      "SAVE": "Spara",
      "SAVED": "Medarbetare har uppdaterats",
      "SAVE_FAILED": "Det gick inte att uppdatera medarbetarna"
    }
  }
}
